import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery, useBreakpoint } from '@pharmac-extranet/shared'
import { PharmacMainLogoMono } from '@pharmac/ui'
import { PropsWithChildren } from 'react'

const ExtranetGradientRoot = styled(ExtranetContainer)`
  background: linear-gradient(130.84deg, rgba(136, 40, 143, 0.83) 65.47%, #66d0d5 99.95%);

  height: 100%;
  position: relative;

  ${MediaQuery.maxTablet} {
    width: 100%;
    padding: var(--spacing-large) var(--spacing-large);
  }

  ${MediaQuery.maxMobile} {
    width: 100%;
    padding: var(--spacing-medium) var(--spacing-medium);
  }
`

const LogoContainer = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;

  ${MediaQuery.maxTablet} {
    bottom: 20px;
    right: 20px;
  }
`

export const ExtranetGradient = ({ children }: PropsWithChildren) => {
  const { minTablet, minDesktop } = useBreakpoint()

  return (
    <ExtranetGradientRoot
      full
      flexColumn
      alignCenter
      justifyCenter={minDesktop}
    >
      {children}
      <LogoContainer>
        <PharmacMainLogoMono
          width={minDesktop ? '309px' : minTablet ? '248px' : '133px'}
          color="white"
        />
      </LogoContainer>
    </ExtranetGradientRoot>
  )
}
